<template>
  <span class="bg-color-slide" :style="`width: ${width}; height: ${height}; border-radius: ${borderRadius}px;`"></span>
</template>

<script>
export default {
  name: 'SkeletonLoader',
  props: {
    height: {
      type: String,
      default: '100%'
    },
    width: {
      type: String,
      default: '100%'
    },
    borderRadius: {
      type: Number,
      default: 4
    }
  }
}
</script>

<style scoped>
.bg-color-slide {
  display:inline-block;
  background: linear-gradient(269deg, #ddd, #eee);
  background-size: 400% 400%;
	-webkit-animation: bg-pan-left 2s infinite both;
	        animation: bg-pan-left 2s infinite both;
}

@-webkit-keyframes bg-pan-left {
  0% {
    background-position: 100% 50%;
  }
  50% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 100% 50%;
  }
}
@keyframes bg-pan-left {
  0% {
    background-position: 100% 50%;
  }
  50% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 100% 50%;
  }
}
</style>